import DocMarkdown from "@/components/DocMarkdown";

import { bridgeDocs } from "../bridge-docs";

/** 消息协议 tab：以 Bridge 消息文档为入口，支持站内跳转到其它 Bridge 文档。 */
export default function MessageProtocolTab() {
  return (
    <DocMarkdown docs={bridgeDocs} docPath="bridge/004-messages/index.md" />
  );
}
